// extracted by mini-css-extract-plugin
module.exports = {"vehicle_tab":"MobileUniversalSearchVehiclesCampgrounds_vehicle_tab__LmYJy"};